export default {
  itens: [],
  selects: {
    compradores: [],
    ano: [
      { value: "2019", text: "2019" },
      { value: "2020", text: "2020" },
      { value: "2021", text: "2021" },
      { value: "2022", text: "2022" },
      { value: "2023", text: "2023" },
      { value: "2024", text: "2024" },
      { value: "2025", text: "2025" },
      { value: "2026", text: "2026" },
      { value: "2026", text: "2027" }
    ],
    mes: [
      { value: "01", text: "janeiro" },
      { value: "02", text: "fevereiro" },
      { value: "03", text: "março" },
      { value: "04", text: "abril" },
      { value: "05", text: "maio" },
      { value: "06", text: "junho" },
      { value: "07", text: "julho" },
      { value: "08", text: "agosto" },
      { value: "09", text: "setembro" },
      { value: "10", text: "outubro" },
      { value: "11", text: "novembro" },
      { value: "12", text: "dezembro" }
    ]
  },
  ano: { value: "2021", text: "2021" },
  orcamento: {
    comprador: "",
    ano: "",
    itens: []
  }
};
